// extracted by mini-css-extract-plugin
export default {"button":"buttonStyles_button__0NCUq"};